import {
  CUSTOMERS_FETCH_SUCCESS,
  DOWNLOAD_CUSTOMERS_SUCCESS,
  SET_CUSTOMERS_DRAFT,
  CUSTOMER_FETCH_SUCCESS,
  CUSTOMER_PROFILE_FETCH_SUCCESS,
  CUSTOMER_SET_DRAFT,
  CUSTOMER_PROFILE_SET_DRAFT,
  CUSTOMER_LOADING,
  GENERATE_USERS_PASSWORD_SUCCESS,
  CREATE_CUSTOMER,
  REMOVE_ITEM_FROM_CUSTOMER_DRAFT
} from '../constant/actionType';

const initialState = {
  csv: null,
  customerDraft: {},
  customerProfile: {},
  customerProfileDraft: {},
  customers: [],
  customersDraft: {},
  isLoaded: false,
  password: '',
  selectedCustomer: {}
};

const costumersReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CUSTOMER:
      return {
        ...state,
        customers: [...state.customers, action.data]
      };
    case CUSTOMERS_FETCH_SUCCESS:
      return {
        ...state,
        customers: action.data
      };
    case DOWNLOAD_CUSTOMERS_SUCCESS:
      return {
        ...state,
        csv: action.data
      };
    case SET_CUSTOMERS_DRAFT:
      return {
        ...state,
        customersDraft: action.data
      };
    case CUSTOMER_FETCH_SUCCESS:
      return {
        ...state,
        customerDraft: action.data,
        selectedCustomer: action.data
      };
    case CUSTOMER_PROFILE_FETCH_SUCCESS:
      return {
        ...state,
        customerProfile: action.data,
        customerProfileDraft: action.data,
        isLoaded: true
      };
    case CUSTOMER_SET_DRAFT:
      return {
        ...state,
        customerDraft: { ...state.customerDraft, ...action.data }
      };
    case REMOVE_ITEM_FROM_CUSTOMER_DRAFT: {
      const newCustomerDraft = {
        ...state.customerDraft
      };
      delete newCustomerDraft[action.data];

      return {
        ...state,
        customerDraft: { ...newCustomerDraft }
      };
    }
    case CUSTOMER_PROFILE_SET_DRAFT:
      return {
        ...state,
        customerProfileDraft: { ...state.customerProfileDraft, ...action.data }
      };
    case CUSTOMER_LOADING:
      return {
        ...state,
        isLoaded: false
      };
    case GENERATE_USERS_PASSWORD_SUCCESS:
      return { ...state, password: action.data };
    default:
      return state;
  }
};

export default costumersReducer;
